import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';

@Injectable({
    providedIn: 'root'
})
export class VisitorFollowUpService extends ApiService {
    getByVisitors(data: any) {
        return super.post('/visitors-follow-up/visitors', data);
    }

    create(data: any) {
        return super.post('/visitors-follow-up/create', data);
    }

    update(data: any) {
        return super.put('/visitors-follow-up/update', data);
    }

    delete(id: number) {
        return super.delete('/visitors-follow-up/' + id);
    }
}
